import React from 'react';

import { FiChevronUp, FiChevronDown } from 'react-icons/fi';

import { VISIT_TYPES } from '../../utils/constants';

import { formatDateDDMMMYYYY } from '../../utils/dateFormat';



const SORT_KEYS = {

  visitId: 'displayVisitCode',

  site: 'siteCode',

  visitType: 'visitType',

  visitDate: 'visitDate',

  status: 'letterStatus',

  recordedOn: 'recordedOn',

};



const VisitLetterGrid = ({

  rows,

  letterKind,

  loading,

  sortBy,

  sortOrder,

  onSort,

  onPreview,

  onDownload,

  downloadingId,

  emptyMessage = 'No letters found for selected filters.',

}) => {

  const SortIcon = ({ column }) => {

    if (sortBy !== column) return null;

    return sortOrder === 'asc' ? <FiChevronUp size={14} /> : <FiChevronDown size={14} />;

  };



  const getField = (row, ...keys) => {

    for (const k of keys) {

      if (row[k] != null && row[k] !== '') return row[k];

    }

    return null;

  };



  return (

    <div className="data-grid-table-wrapper table-responsive">

      <table className="visit-letter-table">

          <thead>

            <tr>

              <th>

                <button type="button" className="visit-letter-th-sort" onClick={() => onSort('visitId')}>

                  Visit ID <SortIcon column="visitId" />

                </button>

              </th>

              <th>

                <button type="button" className="visit-letter-th-sort" onClick={() => onSort('site')}>

                  Site <SortIcon column="site" />

                </button>

              </th>

              <th>

                <button type="button" className="visit-letter-th-sort" onClick={() => onSort('visitType')}>

                  Visit Type <SortIcon column="visitType" />

                </button>

              </th>

              <th>

                <button type="button" className="visit-letter-th-sort" onClick={() => onSort('visitDate')}>

                  Visit Date <SortIcon column="visitDate" />

                </button>

              </th>

              <th>

                <button type="button" className="visit-letter-th-sort" onClick={() => onSort('status')}>

                  Status <SortIcon column="status" />

                </button>

              </th>

              <th>

                <button type="button" className="visit-letter-th-sort" onClick={() => onSort('recordedOn')}>

                  Sent Date <SortIcon column="recordedOn" />

                </button>

              </th>

              <th className="text-center">Actions</th>

            </tr>

          </thead>

          <tbody>

            {loading ? (

              <tr>

                <td colSpan={7} className="empty-state">Loading letters…</td>

              </tr>

            ) : rows.length === 0 ? (

              <tr>

                <td colSpan={7} className="empty-state">{emptyMessage}</td>

              </tr>

            ) : (

              rows.map((row) => {

                const letterId = getField(row, 'letterId', 'LetterId');

                const visitCode = getField(row, 'displayVisitCode', 'DisplayVisitCode') ?? '—';

                const siteCode = getField(row, 'siteCode', 'SiteCode') ?? '—';

                const siteName = getField(row, 'siteName', 'SiteName');

                const vt = getField(row, 'visitType', 'VisitType');

                const visitTypeLabel = VISIT_TYPES[vt] || vt || '—';

                const visitDate = getField(row, 'visitDate', 'VisitDate');

                const status = getField(row, 'letterStatus', 'LetterStatus') ?? '—';

                const recordedOn = getField(row, 'recordedOn', 'RecordedOn');

                const siteDisplay = siteName ? `${siteCode} – ${siteName}` : siteCode;

                const isDownloading = downloadingId === letterId;



                return (

                  <tr key={`${letterKind}-${letterId}`}>

                    <td className="font-bold">{visitCode}</td>

                    <td>{siteDisplay}</td>

                    <td>{visitTypeLabel}</td>

                    <td>{visitDate ? formatDateDDMMMYYYY(visitDate) : '—'}</td>

                    <td><span className="visit-letter-status">{status}</span></td>

                    <td>{recordedOn ? formatDateDDMMMYYYY(recordedOn) : '—'}</td>

                    <td className="text-center visit-letter-actions">

                      <button

                        type="button"

                        className="btn btn-sm btn-secondary"

                        onClick={() => onPreview(row)}

                        title="Preview letter"

                      >

                        Preview

                      </button>

                      <button

                        type="button"

                        className="btn btn-sm btn-primary"

                        onClick={() => onDownload(row)}

                        disabled={isDownloading}

                        title="Download"

                      >

                        {isDownloading ? 'Downloading…' : 'Download'}

                      </button>

                    </td>

                  </tr>

                );

              })

            )}

          </tbody>

        </table>

    </div>

  );

};



export { SORT_KEYS };

export default VisitLetterGrid;


